import React from 'react';
import { css } from '@emotion/core';
import Button from '@atlaskit/button';
import EditorWarningIcon from '@atlaskit/icon/glyph/editor/warning';
import { token } from '@atlaskit/tokens';

import { colors, SPACE_COMPACT } from '@/styles';
import { GraphState } from '@/components/composed/slo-card/graph/types';

const tabStyles = (align: string) => css`
  display: flex;
  justify-content: ${align === 'left' ? 'flex-start' : 'flex-end'};
  gap: ${SPACE_COMPACT}px;
  margin-bottom: ${SPACE_COMPACT}px;
`;

function GraphTabs({
  setToggleState,
  graphState,
  align = 'right',
}: {
  setToggleState: Function;
  graphState: GraphState;
  align?: 'right' | 'left';
}) {
  const isSelectedGraphState = (state: GraphState) => graphState === state;
  return (
    <div css={tabStyles(align)}>
      <Button
        isSelected={isSelectedGraphState(GraphState.ShowErrorBudgetGraph)}
        appearance="default"
        onClick={() => setToggleState(GraphState.ShowErrorBudgetGraph)}
      >
        Error Budget
      </Button>
      <Button
        testId="slo-card-warnings-button"
        isSelected={isSelectedGraphState(GraphState.ShowWarnings)}
        appearance="default"
        onClick={() => setToggleState(GraphState.ShowWarnings)}
        iconBefore={
          <EditorWarningIcon label="" primaryColor={token('color.text.warning', colors.Y500)} />
        }
      >
        Warnings
      </Button>
    </div>
  );
}

export default GraphTabs;
